export default {
	USER: 'user',
	FAILED: 'failed',
};
